import { jsx, Fragment } from "react/jsx-runtime";
import { Box, Heading, Text } from "braid-design-system";
import { shimmerAnimation } from "./SkeletonLine.css.mjs";
const SkeletonLineMoving = ({
  width,
  type,
  level,
  height,
  size,
  children
}) => {
  const content = type === "heading" ? /* @__PURE__ */ jsx(Heading, { component: "span", level, children: children ? children : " " }) : type === "text" && /* @__PURE__ */ jsx(Text, { size, children: children ? children : " " }) || null;
  const shimmerStyles = {
    width,
    ...height ? { height } : {}
  };
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
    Box,
    {
      component: "span",
      display: "block",
      borderRadius: "full",
      height: type === "button" ? "touchable" : void 0,
      position: "relative",
      overflow: "hidden",
      className: shimmerAnimation,
      style: shimmerStyles,
      children: content
    }
  ) });
};
export {
  SkeletonLineMoving
};
